import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx";
import classNames from 'classnames/bind';
import styles from './ExcelUploader.module.scss';

const ACCEPTED_FILE_TYPES = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/vnd.ms-excel", // .xls
];

const cx = classNames.bind(styles);

const ExcelUploader = ({ sendData, selectFile }) => {
    const [data, setData] = useState([]);
    const [error, setError] = useState("");
    const [fileName, setFileName] = useState("");

    const onDrop = (acceptedFiles) => {
        setError("")
        selectFile()
        const file = acceptedFiles[0];

        if (!ACCEPTED_FILE_TYPES.includes(file.type)) {
            setError("File not supported")
            return
        }

        setFileName(file.name)

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });

            // Read first sheet
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            // Convert to JSON
            const parsedData = XLSX.utils.sheet_to_json(sheet);
            setData(parsedData);
            sendData(parsedData)
        };

        reader.readAsBinaryString(file);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: ACCEPTED_FILE_TYPES.join(','),
    });

    return (
        <div className={cx('ExcelUploader')}>
            <div>
                <button {...getRootProps()}>
                    <input {...getInputProps()} />
                    Drag & drop an Excel file here, or click to select
                </button>
                {error && <p className={cx('error')}>{error}</p>}
            </div>
            <div>{fileName}</div>
        </div>
    );
};

export default ExcelUploader;
